import React, { useContext } from 'react';

import { LifeServiceContext } from '@/layouts/MobileLayout/MobileLayout';

import type { LifeService, Services } from '../../sharedTypes';
import styles from './index.module.scss';

type SectionProps = {
  data: LifeService;
  setCurrentServicePage: React.Dispatch<
    React.SetStateAction<Services | undefined>
  >;
};

const Section = ({ data, setCurrentServicePage }: SectionProps) => {
  const { setShowBackButton } = useContext(LifeServiceContext);

  const { sectionName, services } = data;
  consol;

  return (
    <div className={styles.sectionWrapper}>
      <h5 className={styles.sectionName}>{sectionName}</h5>
      <div className={styles.sectionContentContainer}>
        {services.map((service, index) => {
          return (
            <div
              key={index}
              className={styles.serviceContentContainer}
              onClick={() => {
                setCurrentServicePage(service.dataIndex);
                setShowBackButton(true);
              }}
            >
              <div className={styles.iconContainer}>
                <img
                  src={service.icon}
                  alt={service.text}
                  className={styles.icon}
                />
              </div>
              <h4 className={styles.serviceText}>{service.text}</h4>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Section;
